export default {
    'add-new-company': 'إضافة شركة جديدة',
    'this-company': 'هذه الشركة'
}